import { type SubmitHandler, useForm } from 'react-hook-form';

import {
    Description,
    FieldError,
    Form,
    Label,
    Submit,
    TextField,
    TextInput,
    toast,
} from '@gitbook/spine-react';

import { normalizeSiteTitle, SITE_TITLE_LIMIT } from '../../../../../Components';
import { NavigationLink } from '../../../../../navigation';
import { apiClient, useSiteContext } from '../../../../../state';

/**
 * Form field to rename the site in settings
 */
export function RenameSite() {
    const { site, organizationId } = useSiteContext();
    const form = useForm<{ title: string }>({ defaultValues: { title: site.title } });
    const onSubmit: SubmitHandler<{ title: string }> = async (data) => {
        const title = normalizeSiteTitle(data.title);

        if (title === site.title) {
            form.reset();
            return;
        }

        await toast.catch(async () => {
            await apiClient.sites.updateSiteById(organizationId, site.id, {
                title,
            });
            form.reset({ title });
        }, 'Error while updating site title');
    };

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)}>
            <TextField name="title" maxLength={SITE_TITLE_LIMIT}>
                <Label>Rename site</Label>
                <Description>
                    Update the site's name shown within GitBook. To change the title displayed on
                    the published site, go to{' '}
                    <NavigationLink
                        to={{
                            screen: {
                                type: 'site',
                                organization: organizationId,
                                tab: {
                                    type: 'customization',
                                    tab: 'general',
                                },
                            },
                        }}
                    >
                        customization settings
                    </NavigationLink>
                    .
                </Description>
                <div className="flex gap-4">
                    <TextInput type="text" />
                    <Submit label="Save" />
                </div>
                <FieldError />
            </TextField>
        </Form>
    );
}
